// 1: grupo, 2: basic, 3: collapsable, 4: divider
export class UsuarioAS {
    idUsuario: string;
    cNombreUsuario: string;
    cNombreCompleto: string;
    cNombreCorto: string;
    cPerfil: string;
    roleId: string;
    cInstitucion: string;
    institutionId: string;

    constructor() {
        this.idUsuario = "";
        this.cNombreUsuario = "";
        this.cNombreCompleto = "";
        this.cNombreCorto = "";
        this.cPerfil = "";
        this.roleId = "";
        this.cInstitucion = "";
        this.institutionId = "";
    }
}
